import React, {ComponentType} from "react";
import RepeatBookings from './index';
import {
  IProps,
  IContainerProps,
  IBaseProps,
  classPrefix,
  IServices
} from './types';

/**
 * Gets the interface types as array of strings so we don't need hand code them each time (and reduces chance for mistakes).
 */
import {keys} from 'ts-transformer-keys';
import {hot} from "react-hot-loader";
import ReactUtilsService from "app/services/reactUtils.service";
import TableSelectionService from "external-services/table-selection-service/index";
import {ITableItem} from "shared-types/index";
import {uniqueCssClassPrefix} from "app/diary.module.helpers";

const NS = 'RepeatBookingContainer';

const propsKeys: string[] = keys<IProps>();
const basePropsKeys: string[] = keys<IBaseProps>();
const containerPropsKeys: string[] = keys<IContainerProps>();
const servicesKeys: string[] = keys<IServices>();

const ThemeWrap = function (all: IContainerProps & IServices) {

  const props: IProps = ReactUtilsService.getObjectByKeys(all, propsKeys) as IProps;
  const containerProps: IContainerProps = ReactUtilsService.getObjectByKeys(all, containerPropsKeys) as IContainerProps;

  const selectedTableIds = containerProps.bookingInfo.tables?.map(function (table) {
    return table._id;
  });

  /**
   * Needed to get unique class names each time because there is a risk of class name clashes between different
   * instances of the same component. They use a counter to generate uniqueness, but this starts at 0 for each
   * component and therefore needs some other unique prefix, other than just the static 'classPrefix'.
   * Generating it on each render is a bit overkill, but there is no reliable way to get an id for each instance.
   */

  const tableSeaterProps = {
    classPrefix: 'RecurringBooking',
    isWhiteTheme: false,
    label: '',
    manualJoinType: containerProps.manualJoinType,
    selectedTableIds,
    selectedTime: containerProps.selectedTime,
    showEmptyTableValidationMessage: false,
    tables: containerProps.tableList,
    useReversedColors: false,
    tableSelectionList: [] as ITableItem[],
    tableSelectionListWithJoins: [] as ITableItem[],
    sectionsLookup: containerProps.sectionsLookup,
    preselectedTableIds: selectedTableIds as string[],
    handleUpdate: (selectedTableIds: string[], tables: ITableItem[], isManualJoin: boolean) => {
      // no need call it anymore
    }
  }

  /**
   * Needed to get unique class names each time because there is a risk of class name clashes between different
   * instances of the same component. They use a counter to generate uniqueness, but this starts at 0 for each
   * component and therefore needs some other unique prefix, other than just the static 'classPrefix'.
   * Generating it on each render is a bit overkill, but there is no reliable way to get an id for each instance.
   */
  const uniqueClassPrefix = `${classPrefix}-${uniqueCssClassPrefix()}`;
  tableSeaterProps.classPrefix = uniqueClassPrefix;

  /**
   * Passes all base props from container to component
   */
  // @ts-ignore
  basePropsKeys.forEach(key => props[key] = containerProps[key]);
  props.tableSeaterRecurringParams = TableSelectionService.getTableSeaterProps(tableSeaterProps);
  // props.updatedBooking = updatedBooking;
  props.classPrefix = uniqueClassPrefix;
  return ReactUtilsService.containerWrap(
    <RepeatBookings {...props} />, uniqueClassPrefix
  );
}

/**
 * Returns properties needed for rendering react2angular
 */
export const R2ARepeatBooking: [ComponentType<unknown>, never[]?, string[]?] = [
  hot(module)(ThemeWrap) as ComponentType<unknown>,
  [...containerPropsKeys] as never[],
  servicesKeys
];
